import { Theme } from "@mui/material";
import { colors } from "../../constants/colors";

const styles = {
  paddingBottom: '5rem',
  maxWidth: '32rem',
  '& .MuiPaper-root': {
    color: colors.black,
    backgroundColor: colors.tertiary,
    borderLeft: '2px solid ' + colors.primary,
    
  },
  '& .MuiAccordionSummary-content': {
    fontWeight: '400'
  },
  '& .MuiAccordionDetails-root': {
    backgroundColor: colors.tertiary
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: colors.black
  },
  '& h3': {
    color: colors.secondary,
    fontSize: '1rem',
    fontWeight: '500',
    transition: 'color 0.3s'
  },
  '& .Mui-expanded': {
    '& h3': {
      color: colors.black,
    }
  }
};

const accordionStyles: any = (theme?: Theme) => styles;

export default accordionStyles;